import { render, staticRenderFns } from "./modal-production-completely-relieve-load.vue?vue&type=template&id=f20dc2a8&scoped=true&"
import script from "./modal-production-completely-relieve-load.vue?vue&type=script&lang=js&"
export * from "./modal-production-completely-relieve-load.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-completely-relieve-load.vue?vue&type=style&index=0&id=f20dc2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20dc2a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f20dc2a8')) {
      api.createRecord('f20dc2a8', component.options)
    } else {
      api.reload('f20dc2a8', component.options)
    }
    module.hot.accept("./modal-production-completely-relieve-load.vue?vue&type=template&id=f20dc2a8&scoped=true&", function () {
      api.rerender('f20dc2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-completely-relieve-load.vue"
export default component.exports